export default __webpack_public_path__ + "c95abbe8630c5db3a26218809fa49c96.svg";